// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"05759c73","513":"d5c00c5e"}[chunkId] + ".chunk.js";
};